<style>
  .customer-dropdown {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid #dddddd;
    padding: 10px;
    max-height: 200px;
    overflow-y: scroll;
  }
  /* remove the margin between the customer rows */
  .customer-dropdown > div {
    margin: 0px;
  }
  .customer-row {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 4px 4px;
    margin: -4px 0px;
  }
  .customer-row:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
</style>

<div>


  <div [hidden]="addingCustomer || selectedCustomer">
    <div style="margin-bottom:15px;">
      <div>
        <app-textbox #txtSearchCustomers [label]="'Find a customer'" style="margin-bottom:0px;" (keyup)="txtSearchCustomers_keyup($event.target.value)"></app-textbox>
      </div>
      <div [hidden]="!searchingCustomers" style="margin-bottom:15px; font-size: .9em;">
        <div class="customer-dropdown" [hidden]="!searchResults || searchResults.records.length == 0">
          <div *ngFor="let customer of searchResults.records">
            <div class="customer-row" (click)="btnSelectCustomer_click(customer.id)">
              <div>{{ customer.firstName }} {{ customer.lastName }}</div>
              <div>{{ customer.emailAddress }}</div>
              <div>{{ formatPhone(customer.phone, customer.ccCode) }}</div>
              <div>{{ customer.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div (click)="btnAddCustomer_click()" [hidden]="selectedCustomer">
      <span style="font-size:.9em; font-weight:500; cursor: pointer; color:var(--green-700); text-decoration: underline;">+ Add New Customer</span>
    </div>
  </div>

  <div [hidden]="!addingCustomer" class="greenContainer">
    <div style="display: flex; flex-direction: row; gap: 10px; width:100%; justify-content: space-between;">
      <div>
        Add New Customer
      </div>
      <div style="text-align: right;" (click)="btnCancelAddCustomer_click()">
        <span style="font-size:.9em; font-weight:500; cursor: pointer; color:var(--green-700); text-decoration: underline;">remove</span>
      </div>
    </div>

    <div style="display: flex; flex-direction: row; gap: 10px;">
      <app-textbox [label]="'First Name'" [required]="true" [(ngModel)]="newCustomer.firstName"></app-textbox>
      <app-textbox [label]="'Last Name'" [required]="true" [(ngModel)]="newCustomer.lastName"></app-textbox>
    </div>
    <div style="display: flex; flex-direction: row; gap: 10px;">
      <app-textbox [label]="'Email Address'" [required]="true" [type]="inputTextModes.Email" [(ngModel)]="newCustomer.emailAddress"></app-textbox>
      <app-textbox [label]="'Phone Number'" [required]="false" [type]="inputTextModes.Phone" [guidedFormat]="'xxx-xxx-xxxx'" [(ngModel)]="newCustomer.phone"></app-textbox>
    </div>

    <div style="text-align: center;" (click)="btnAcceptNewCustomer_click()">
      <span style="font-size:.9em; font-weight:500; cursor: pointer; color:var(--green-700); text-decoration: underline;">save</span>
    </div>

  </div>

  <div [hidden]="!selectedCustomer" class="greenContainer">
    <div style="display: flex; flex-direction: row; gap: 10px;">
      <div style="flex: 1">
        {{ selectedCustomer?.firstName }} {{ selectedCustomer?.lastName }}<br />
        <div [hidden]="!selectedCustomer?.emailAddress">
          {{ selectedCustomer?.emailAddress }}
        </div>
        @if (
          selectedCustomer && selectedCustomer.phone && selectedCustomer.ccCode
        ) {
          <div>
            {{ formatPhone(selectedCustomer.phone, selectedCustomer.ccCode) }}
          </div>
        }
      </div>
      <div style="text-align: right;" (click)="btnCancelAddCustomer_click()">
        <span style="font-size:.9em; font-weight:500; cursor: pointer; color:var(--green-700); text-decoration: underline;" [hidden]="readonly">remove</span>
      </div>
    </div>

  </div>

</div>